<script setup>
const metadata = useMetadata()
</script>

<template>
  <a :href="`mailto:${metadata?.customerService?.clubEmail}`">
    {{ metadata?.customerService?.clubEmail }}
  </a>
</template>
